import {createAsyncThunk} from '@reduxjs/toolkit';
import {SUCCESS_DATA, TIME_DIFFERENCE, UNSUCCESS_DATA} from './constants';
import api from 'services/axios';
import {changeDateFormat} from 'utils/Helper';

export const getReports = createAsyncThunk<any, any>(
  'getReports',
  async ({startDate = '2023-05-21', endDate = '2023-05-21', vendorId = '110289'}: any) => {
    try {
      const response = await api.get(
        `vendor/orders-details?fromDate=${startDate}&toDate=${endDate}&vendorId=${vendorId}`
      );

      const {allTotalPrice, totalOrderCount, onlineDeliveryPrice} = response.data.meta;

      return {
        allTotalPrice,
        totalOrderCount,
        onlineDeliveryPrice
      };
    } catch (e: any) {
      console.warn(e);
    }
  }
);

export const getDailyChartReports = createAsyncThunk<any, any>(
  'getDailyChartReports',
  async ({startDate, endDate, vendorId}: any) => {
    try {
      const response = await api.get(
        `vendor/daily-sales-report?fromDate=${startDate}&toDate=${endDate}&vendorId=${vendorId}`
      );
      const chartData = response?.data?.data?.map((report) => ({
        name: changeDateFormat(report?.attributes?.date),
        [SUCCESS_DATA]: +report?.attributes?.successOrders,
        [UNSUCCESS_DATA]: +report?.attributes?.unSuccessOrders
      }));
      return chartData;
    } catch (e: any) {
      console.warn(e);
    }
  }
);
export const getDelayChartReports = createAsyncThunk<any, any>(
  'getDelayChartReports',
  async ({daysAgo, vendorId}: any) => {
    try {
      const response = await api.get(
        `vendor/delay-orders-report?daysAgo=${daysAgo}&vendorId=${vendorId}`
      );
      const chartData = response?.data?.data?.barChartItems.map((report) => ({
        name: changeDateFormat(report?.hour_slot),
        [TIME_DIFFERENCE]: +report?.timedifference_in_minutes
      }));

      return chartData;
    } catch (e: any) {
      console.warn(e);
    }
  }
);

export const getOrders = createAsyncThunk<any, any>(
  'getOrders',
  async ({page = 0, pageSize = 10, vendorId, searchTerm = '', startDate, endDate}: any) => {
    try {
      const ordersResponse = await api.get(
        `order/list?pageSize=${pageSize}&page=${page}&vendorId=${vendorId}&searchQuery=${searchTerm}&startDate=${startDate}&endDate=${endDate}`
      );
      const {data: orders, pagination} = ordersResponse?.data ?? {};

      return {orders, pagination};
    } catch (e: any) {
      console.warn(e);
    }
  }
);

export const getProductsById = createAsyncThunk<any, any>(
  'getProductsById',
  async ({orderId}: any) => {
    try {
      const productsResponse = await api.get(`order/products?orderId=${orderId}`);

      const {data, meta} = productsResponse?.data ?? {};
      return {products: data, orderId: meta.orderProductId};
    } catch (e: any) {
      console.warn(e);
    }
  }
);
